import i18n from "../../../../i18n";

export enum INSTANCE_COL_IDS {
  SERVICE = 'SERVICE',
  ODOMETER = 'ODOMETER',
  COST = 'COST',
  KM = 'KM',
  KM_INSTANCE = 'KM_INSTANCE',
  MONTH = 'MONTH',
  MONTH_INSTANCE = 'MONTH_INSTANCE'
}

export const INSTANCE_COLUMNS = {
  [INSTANCE_COL_IDS.SERVICE]: {
    id: INSTANCE_COL_IDS.SERVICE,
    label: i18n.t('Service'),
    path: 'description'
  },
  [INSTANCE_COL_IDS.ODOMETER]: {
    id: INSTANCE_COL_IDS.ODOMETER,
    label: i18n.t('Km'),
    path: 'actual_value'
  },
  [INSTANCE_COL_IDS.COST]: {
    id: INSTANCE_COL_IDS.COST,
    label: i18n.t('Cost'),
    path: 'cost'
  },
  [INSTANCE_COL_IDS.KM]: {
    id: INSTANCE_COL_IDS.KM,
    label: 'km',
    path: 'description',
    width: { min: '120px', max: '200px' },
    isPinned: true
  },
  [INSTANCE_COL_IDS.KM_INSTANCE]: {
    id: INSTANCE_COL_IDS.KM_INSTANCE,
    label: 'km',
    path: 'instance_id',
    width: '82px',
    isDynamic: true
  },
  [INSTANCE_COL_IDS.MONTH]: {
    id: INSTANCE_COL_IDS.MONTH,
    label: 'month',
    path: 'description',
    width: { min: '120px', max: '200px' },
    isPinned: true
  },
  [INSTANCE_COL_IDS.MONTH_INSTANCE]: {
    id: INSTANCE_COL_IDS.MONTH_INSTANCE,
    label: 'month',
    path: 'instance_id',
    width: '82px',
    isDynamic: true
  }
}
